import * as SockJS from "sockjs-client";
import { Stomp } from "@stomp/stompjs";
import { useRef, useState } from 'react';

let socket;
let stompClient;

const useSocket = (url) => {
  const [connected, setConnected] = useState(false);
  const [lostConnect, setLostConnect] = useState(1);

  const timer = useRef()

  const disconnectHandler = () => {
    setConnected(false);
    socket = null
    stompClient = null

    if(timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => {
      setLostConnect((prevState) =>
        prevState > 60 ? 1 : prevState * 2
      );
    }, lostConnect * 1000);
  }

  const init = (jwt) => {
    if (!url || !jwt) return;

    if (!socket) {
      socket = new SockJS(url);
    }
    if (!stompClient && socket) {
      stompClient = Stomp.over(socket);
      stompClient.debug = () => {};
    }

    //console.log('init', stompClient)

    if (!connected) {
      return new Promise((resolve) => {
        stompClient.connect(
          {
            "X-Authorization": jwt,
          },
          (e) => {
            //---- connect callback

            //console.log("con-1", e, stompClient);
            setConnected(true);

            resolve(true);
          },
          (err) => {
            //---- error callback

            //console.log("err-1 ", err);

            disconnectHandler()
            resolve(false);
          },
          () => {
            //---- close callback

            //console.log("close-1");

            disconnectHandler()
            resolve(false);
          }
        );
      });
    }
  };

  const subscribe = (endpoint, token, callback) => {
    return stompClient.subscribe(endpoint, callback, {
      "X-Authorization": token,
    });
  };

  const send = (endpoint, data) => {
    return stompClient.send(endpoint, {}, JSON.stringify(data));
  };

  const disconnect = () => {
    if (stompClient) stompClient.disconnect();
    setConnected(false);
  };

  return { init, subscribe, connected, send, lostConnect, disconnect };
};

export default useSocket;
